import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caret-up",
  "use": "icon-caret-up-usage",
  "viewBox": "0 0 320 512",
  "content": "<symbol aria-hidden=\"true\" class=\"svg-inline--fa fa-caret-up fa-w-10\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 320 512\" id=\"icon-caret-up\"><path fill=\"currentColor\" d=\"M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol